import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2ap734k32w: FaireBrandEntity = {
  token: "b_2ap734k32w",
  type: "brand",
  name: "Simply Honest Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/382f910538e699902aad02823c2559e18e7425264f704e62cb4fda74721fce60.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ee33f15bf3d3a3d2fdc7b817bfa3341f691c3b7d945158a1fd262c3acfbfa6b1.png",
  logoUrl:
    "https://cdn.faire.com/fastly/382f910538e699902aad02823c2559e18e7425264f704e62cb4fda74721fce60.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ee33f15bf3d3a3d2fdc7b817bfa3341f691c3b7d945158a1fd262c3acfbfa6b1.png",
  location: "Elkton, TN, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 38,
  isTopShop: true,
  isInsider: true,
  description:
    "NO Fillers  |  NO Heavy Metals  |  NO Additives  |  NEVER Mass Produced . . . Hi there! We are Brenda and Sandy, founders and owners of Simply Honest Co. We have families and pets, and have had our share of health issues that have led us to our search for honest, simple and meaningful solutions that we just can't find in the current world of medicine and nutrition. \n\nOnce big city girls with busy lives in the Nashville, TN area, we've both gone country in the last several years. Being close to nature and away from the madness of city life has really opened our eyes and ears to the possibilities and potential of natural paths to wellness, getting away from the chemicals, fillers, toxins and other harmful ingredients that everything on the store shelf seems to have these days. \n\nAfter searching for new ways to treat and deal with pain, allergies, illness, and other ailments, we found some amazing results in simple plants. Nothing fancy, no complicated concoctions. Just pure plant materials found in nature, many even in our own back yards here in Tennessee and Alabama. \n\nWe are so excited to provide the best quality products that we can find -  responsibly sourced, organically farmed, and ethically harvested and processed. We take great joy in knowing we can sleep in peace at night assured that you and your family are receiving honest, simple, and effective products for your heath and home. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:03.099Z",
    importedBy: "entity-db-cli",
  },
};
